import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const mergeTailwindClasses = (...classnames: ClassValue[]) => twMerge(clsx(...classnames));
